<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="transportation">
                    <icon name="truck"></icon>
                    ขนส่ง
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "transport-layout"
    }
</script>

<style scoped>

</style>